import React, { useState, useEffect } from 'react';
import { notification, Skeleton } from 'antd';

import CountriesForm from '../../../containers/CountriesForm/index';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';

import { post, put, get } from '../../../api/module/countries';

const CountriesForms = ({ history, match }) => {
  const [countryID] = useState(parseInt(match.params.id));
  const [title, setTitle] = useState('Creación de Países');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const save = async (data) => {
    try {
      let response;
      setLoading(true);

      if (!countryID) {
        response = await post(data);
      } else {
        response = await put(countryID, data);
      }

      setLoading(false);

      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(INTERNAL_LINKS.COUNTRIES);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);

      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
    }
  };

  // Get Data Area by ID
  const handleGet = () => {
    try {
      if (countryID) {
        get(countryID).then((res) => setData(res.data));
        setTitle('Actualización de Países');
      } else {
        setData({});
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_GET_MSG,
        duration: 2,
      });
    }
  };

  useEffect(() => {
    handleGet();
  }, []);

  return (
    <Skeleton loading={data === null}>
      <CountriesForm
        title={title}
        onFinish={save}
        initialValues={data}
        loading={loading}
      />
    </Skeleton>
  );
};

export default CountriesForms;
